<template>
  <el-dialog
    id="create-modal"
    class="form-modal"
    :visible.sync="createVisible"
    v-loading="createProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="create-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">Create Conference Bridge</h1>
        <div class="modal-actions col-2">
          <el-button
            type="primary"
            @click="createOperation"
            :disabled="numUsed"
          >
            Create
          </el-button>
          <el-button type="default" @click="cancelOperation">Cancel</el-button>
        </div>
      </div>
    </div>

    <el-form>
      <el-tabs v-model="activeTabName">
        <!-- ⭐ GENERAL ⭐ -->
        <el-tab-pane label="General" name="general">
          <div class="inline-form-group">
            <el-col :span="12">
              <el-input v-model="createForm.number" placeholder="Enter number"
                ><template slot="prefix">Number</template>
                <template v-if="numUsed" slot="append">
                  <in-use :inUse="numInUse" />
                </template>
              </el-input>
            </el-col>
            <el-col :span="1" />
            <el-col :span="11">
              <el-input v-model="createForm.name" placeholder="Enter name">
                <template slot="prefix">Name</template>
              </el-input>
            </el-col>
          </div>
          <div class="inline-form-group">
            <el-col :span="12">
              <el-input v-model="createForm.pin" placeholder="Enter pin">
                <template slot="prefix">Pin</template>
              </el-input>
            </el-col>
            <el-col :span="1" />
            <el-col :span="11">
              <el-input
                v-model="createForm.adminpin"
                placeholder="Enter admin pin"
              >
                <template slot="prefix">Admin pin</template>
              </el-input>
            </el-col>
          </div>
          <el-input
            v-model="createForm.sendReportEmail"
            placeholder="Enter conference report email"
          >
            <template slot="prefix">Email report to</template>
          </el-input>
          <div>
            <el-select
              v-model="createForm.maxusers"
              placeholder="Select max allowed users"
            >
              <template slot="prefix">Max allowed users</template>
              <el-option v-for="n in 100" :key="n" :value="n">
                {{ n }}
              </el-option>
            </el-select>
          </div>
        </el-tab-pane>

        <el-tab-pane label="Media" name="media">
          <new-mediafile @mediafileSaved="newMediaFile = $event" />

          <!-- ⭐ Request PIN Message ⭐ -->
          <existing-mediafile
            title="Request PIN Message"
            :multiple="false"
            :clearState="clearFormFields"
            :newMediafile="newMediaFile"
            @mediafileSelected="createForm.requestPinMeId = $event"
          />

          <!-- ⭐ Correct PIN Message ⭐ -->
          <existing-mediafile
            title="Correct PIN Message"
            :multiple="false"
            :clearState="clearFormFields"
            :newMediafile="newMediaFile"
            @mediafileSelected="createForm.correctPinMeId = $event"
          />

          <!-- ⭐ Correct Admin PIN Message ⭐ -->
          <existing-mediafile
            title="Correct Admin PIN Message"
            :multiple="false"
            :clearState="clearFormFields"
            :newMediafile="newMediaFile"
            @mediafileSelected="createForm.correctAdminPinMeId = $event"
          />
        </el-tab-pane>

        <!-- ⭐ SETTINGS TAB ⭐ -->
        <el-tab-pane label="Settings" name="settings">
          <el-checkbox v-model="settings.announceUsersCount.checked">
            Announce Users Count
          </el-checkbox>
          <el-checkbox
            v-model="settings.announceUsersJoinOrLeaveWithReview.checked"
          >
            Announce User Join/Leave With Review
          </el-checkbox>
          <el-checkbox
            v-model="settings.announceUsersJoinOrLeaveWithoutReview.checked"
          >
            Announce User Join/Leave Without Review
          </el-checkbox>
          <el-checkbox v-model="settings.playMoh.checked">
            Play MOH when only one user
          </el-checkbox>
          <el-checkbox v-model="settings.allowAccessToMenu.checked">
            Allow Access to Menu With *
          </el-checkbox>
          <el-checkbox v-model="settings.donotPlayMessage.checked">
            Do Not Play Message When First Person Enters
          </el-checkbox>
          <el-checkbox v-model="settings.waitForAdmin.checked">
            Wait For Admin Before Starting Conference
          </el-checkbox>
          <el-checkbox v-model="settings.joinUserMuted.checked">
            Join User Muted
          </el-checkbox>
          <el-checkbox v-model="settings.endConference.checked">
            End The Conference When The Admin Leaves
          </el-checkbox>
          <el-checkbox v-model="settings.recordConference.checked">
            Record The Conference
          </el-checkbox>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </el-dialog>
</template>

<script>
import ExistingMediafile from "@/components/ExistingMediafile";
import NewMediafile from "@/components/NewMediafile";
import InUse from "@/components/InUse";

export default {
  name: "CreateConferenceBridgesForm",

  props: {
    createVisible: { required: true },
    clearFormFields: { required: true },
    createProcessing: { required: true },
    numInUse: { required: true }
  },

  components: { NewMediafile, ExistingMediafile, InUse },

  data() {
    return {
      newMediaFile: null,
      activeTabName: "general",
      requestPinMediafile: null,
      correctPinMediafile: null,
      correctAdminPinMediafile: null,
      createForm: {
        tenantId: null,
        tenantCode: null,
        name: "",
        number: "",
        pin: "",
        adminpin: "",
        requestPinMeId: "",
        correctPinMeId: "",
        correctAdminPinMeId: "",
        sendReportEmail: "",
        maxusers: 50,
        opts: "",
        adminopts: ""
      },

      settings: {
        announceUsersCount: {
          checked: false,
          value: "c"
        },
        announceUsersJoinOrLeaveWithReview: {
          checked: false,
          value: "i"
        },
        announceUsersJoinOrLeaveWithoutReview: {
          checked: false,
          value: "I"
        },
        playMoh: {
          checked: true,
          value: "M"
        },
        allowAccessToMenu: {
          checked: true,
          value: "s"
        },
        donotPlayMessage: {
          checked: false,
          value: "1"
        },
        waitForAdmin: {
          checked: false,
          value: "w"
        },
        joinUserMuted: {
          checked: false,
          value: "m"
        },
        endConference: {
          checked: false,
          value: "x"
        },
        recordConference: {
          checked: false,
          value: "r"
        }
      }
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },

    number() {
      return this.createForm.number;
    },

    numUsed() {
      return this.numInUse && this.numInUse.inUse;
    }
  },

  watch: {
    clearFormFields(value) {
      if (value) {
        this.clearFields();
      }
    },

    number(value) {
      if (value) {
        this.$emit("checkNumber", value);
      } else {
        this.$emit("checkNumber", "****************");
      }
    }
  },

  methods: {
    clearFields() {
      this.activeTabName = "general";
      this.requestPinMediafile = null;
      this.correctPinMediafile = null;
      this.correctAdminPinMediafile = null;

      Object.keys(this.createForm).forEach(key => {
        if (typeof this.createForm[key] === "string") {
          this.createForm[key] = "";
        }
        if (typeof this.createForm[key] === "boolean") {
          this.createForm[key] = false;
        }
        if (typeof this.createForm[key] === "number") {
          this.createForm[key] = null;
        }
      });

      this.createForm.maxusers = 50;

      this.settings = {
        announceUsersCount: {
          checked: false,
          value: "c"
        },
        announceUsersJoinOrLeaveWithReview: {
          checked: false,
          value: "i"
        },
        announceUsersJoinOrLeaveWithoutReview: {
          checked: false,
          value: "I"
        },
        playMoh: {
          checked: true,
          value: "M"
        },
        allowAccessToMenu: {
          checked: true,
          value: "s"
        },
        donotPlayMessage: {
          checked: false,
          value: "1"
        },
        waitForAdmin: {
          checked: false,
          value: "w"
        },
        joinUserMuted: {
          checked: false,
          value: "m"
        },
        endConference: {
          checked: false,
          value: "x"
        },
        recordConference: {
          checked: false,
          value: "r"
        }
      };
    },

    createOperation() {
      let concatStr = "";

      Object.keys(this.settings).forEach(key => {
        const { checked, value } = this.settings[key];
        concatStr += checked ? value : "";
      });

      this.createForm.opts = `T${concatStr}`;
      this.createForm.adminopts = `AaT${concatStr}`;
      this.createForm.tenantId = this.selectedTenant.id;
      this.createForm.tenantCode = this.selectedTenant.tenantCode;

      this.createForm.requestPinMeId = this.createForm.requestPinMeId
        ? this.createForm.requestPinMeId
        : 0;
      this.createForm.correctPinMeId = this.createForm.correctPinMeId
        ? this.createForm.correctPinMeId
        : 0;
      this.createForm.correctAdminPinMeId = this.createForm.correctAdminPinMeId
        ? this.createForm.correctAdminPinMeId
        : 0;

      this.$emit("createOperation", this.createForm);
    },

    cancelOperation() {
      this.$emit("cancelOperation", "create");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/variables";

.checkbox-group {
  max-width: 600px;
  margin: auto;
}

.el-tabs {
  max-width: 600px;
  margin: auto;
}

.el-checkbox {
  margin-left: 0;
}
</style>
